<frg-cards
    [title]="title"
>
<div>
    <h1>Documents administratifs</h1>
    <ul>
        <li>
            <a href="/assets/documents/attestation_SGS.pdf" target="_blank">Liens et partenariats</a>
        </li>
        <li>
            <a href="/assets/documents/attestation_SGS_criteres.pdf" target="_blank">Critères d’engagement de la certification LAP</a>
        </li>
        <li>
          <a href="#" (click)="onDownloadCgu($event)">Télécharger les CGU acceptées</a>
        </li>

    </ul>
</div>
<div class="accordion-container">
  <details>
    <summary>Informations homologation DMP</summary>
    <details>
      <summary>Homologation de DmpConnect (iCanopée)</summary>
      <div class="section">
        <p>
          Le LPS HyperMed Online appuie ses échanges avec le SI-DMP sur le service DmpConnect, édité par
          iCanopée, dont l'homologation date du <i>{{ dmpIcanopeeHomologationDate }}</i> en version
          <i>{{ dmpIcanopeeHomologationVersion }}</i>.
        </p>
        <p>Éditeur : {{ dmpHomologationEditeur }}</p>
        <p>Nom : {{ dmpHomologationNom }}</p>
        <p>Version : {{ dmpHomologationVersion }}</p>
        <p>Date d'homologation : {{ dmpHomologationDate }}</p>
        <p>Profil(s) de DMP-compatibilité :</p>
        <ul>
          <li>- Alimentation</li>
          <li>- Consultation</li>
        </ul>
      </div>
    </details>
    <details>
      <summary>Fonctions DMP intégrées par Hypermed</summary>
      <div class="section">
        <p>Liste des fonctions DMP intégrées :</p>
        <ul>
          <li>- <b>0.2</b> (vérifier l’existence d’un DMP actif (via TD0.2))</li>
          <li>- <b>0.3a</b> (ajouter une autorisation d’accès (TD0.3))</li>
          <li>- <b>0.3b</b> (supprimer une autorisation d’accès (TD0.3))</li>
          <li>- <b>0.9</b> (accès Web-PS Contextuel (TD0.9))</li>
          <li>- <b>2.1a/2.2a</b> (alimenter le DMP d’un patient)</li>
          <li>- <b>2.1b/2.2b</b> (remplacer un document existant)</li>
          <li>- <b>3.1a</b> (sélectionner un document dans le DMP)</li>
          <li>- <b>3.1b</b> (rechercher l’identifiant technique d’un document)</li>
          <li>- <b>3.2</b> (consulter des documents dans le DMP)</li>
          <li>- <b>3.3a</b> (masquer / démasquer un document)</li>
          <li>- <b>3.3b</b> (rendre un document visible au patient)</li>
          <li>- <b>3.3c</b> (supprimer un document)</li>
          <li>- <b>3.3d</b> (archiver / désarchiver un document)</li>
        </ul>
      </div>
    </details>
    <details>
      <summary>Fonctions DMP non intégrées</summary>
      <div class="section">
        <ul>
          <li>- <b>0.4</b> (lister les DMP autorisés (TD0.4))</li>
          <li>- <b>0.5</b> (rechercher un DMP (TD0.5))</li>
          <li>- <b>0.10</b> (accès Web-PS Contextuel en mode AIR (TD0.10))</li>
          <li>- <b>1.3a</b> (consultation des données administratives)</li>
          <li>- <b>1.6</b> (lister les acteurs de santé (TD1.6))</li>
        </ul>
      </div>
    </details>
  </details>



</div>

</frg-cards>
